<template>
  <section class="confirmation-wrapper">
    <h1>{{ $t('pages.confirmation.title') }}</h1>
    <div
      class="message"
      v-html="$t('pages.confirmation.message')"
    />
    <div
      class="info"
    >
      <img :src="VEHICLE.images.high">
      <div class="vehicle">
        {{ $t('pages.confirmation.your_vehicle') }} {{ VEHICLE.label }}
      </div>
      <div class="from-to">
        {{ FROM_TO_DATE }}
      </div>
      <div class="business-name">
        {{ BUSINESS.label }}
      </div>
      <div class="address">
        {{ BUSINESS.address }}
        <br>
        {{ BUSINESS.postal_code }}
        {{ BUSINESS.city && BUSINESS.city.label }}
      </div>
      <rent-button
        is-anchor
        href="/"
      >
        {{ $t('pages.confirmation.return') }}
      </rent-button>
    </div>
  </section>
</template>
<script>
import {
  mapActions, mapMutations, mapGetters, mapState,
} from 'vuex'
import RentButton from '../shared/RentButton'

export default {
  name: 'PaymentSuccess',
  components: {
    RentButton,
  },
  created() {
    const { lead } = window.renaultRent

    this.VEHICLE = lead.vehicle

    this.FROM_TO_DATE = `Du ${lead.date_start} à ${lead.hour_start} au ${lead.date_end} à ${lead.hour_end}`

    this.BUSINESS = lead.business
    this.BUSINESS_RETURN = lead.return_business
  },
  mounted() {
    if (!this.VEHICLE || !this.BUSINESS) {
      window.location = '/'
      return
    }
    this.clearCompletedInfo()
    this['stepping/SET_CURRENT_STEP'](5)
  },
  watch: {
    userIsLogged: {
      immediate: true,
      handler(val) {
        if (!val) {
          return
        }
        this.analytics()
      },
    },
    userInfo: {
      handler() {
        this.geolid()
      },
      deep: true,
    },
  },

  computed: {
    ...mapGetters({
      userIsLogged: 'auth/userIsLogged',
    }),
    ...mapState({
      userInfo: (state) => state.user.details,
    }),

  },
  methods: {
    ...mapMutations([
      'stepping/SET_CURRENT_STEP',
    ]),
    ...mapActions({
      clearCompletedInfo: 'leads/CLEAR_COMPLETED_BOOKING_INFO',
    }),
    geolid() {
      if (!window.gt) {
        return
      }
      /* eslint-disable */
      gt('sendLead', window.renaultRent.type === 'LEAD_DETAILED' ? 'Réservation en agence' : 'Réservation en ligne', {
        'first_name': this.userInfo ? this.userInfo?.first_name : 'null',
        'last_name': this.userInfo ? this.userInfo?.last_name:  'null',
        'address': this.userInfo ? this.userInfo?.address: 'null',
        'email': this.userInfo ? this.userInfo?.email: 'null',
        'phone': this.userInfo ? this.userInfo?.tel : 'null',
        'city': this.userInfo ? this.userInfo?.city : 'null',
        'zip_code': this.userInfo ? this.userInfo?.postal_code : 'null'
      })
      /* eslint-enable */
    },
    analytics() {
      if (!window.dataLayer) {
        return
      }
      const eeAction = 'eeCheckout'
      const checkoutStep = 4
      const containerId = window.renaultRent.gtm_id
      const departureAgency = this.BUSINESS.label
      const loginStatus = this.userIsLogged ? this.userIsLogged : 'N/A'
      const page = window.location.href
      const pageCategory = ''
      const pageTitle = document.querySelector('head title')?.text
      const returnAgency = this.BUSINESS_RETURN.label
      const products = [{
        brand: 'Renault',
        category: this.VEHICLE.type.label === 'VP' ? 'tourism' : 'utilitaire',
        checkoutStep: 4,
        id: this.VEHICLE.semi_clair,
        name: this.VEHICLE.label,
        price: '',
        priceOnline: '',
        priceAgency: '',
        quantity: 1,
        variant: '',
        transactionTotal: window.renaultRent.lead.price,
      }]
      const payload = {
        eeAction,
        checkoutStep,
        containerId,
        departureAgency,
        loginStatus,
        page,
        pageCategory,
        pageTitle,
        returnAgency,
        products,
      }
      // console.log(payload)
      window.dataLayer.push(payload)
    },
  },
}
</script>
<style lang="scss" scoped>

section {
  color: black;
  margin: 0 auto 50px;
  max-width: 700px;

  @include font-size(16px);
}

h1 {
  color: $black;
  font-family: $f-graphie-book;
  margin: 20px auto;

  @include font-size(28px);
}

section ::v-deep a {
  color: black;
  text-decoration: underline;
}

img {
  margin: 50px auto;
}

.info {
  @include font-size(13px);
}

.vehicle,
.from-to,
.address {
  margin: 0 auto 20px;
}
</style>
